import { BASE_URL, GET, USER_REPORT } from "../constants";
import { statusParsing, jsonParsing } from "../utils";
import { getAccessToken } from "../../authActions/authActions";

export const fetchUserReport = async () => {
  const token = await getAccessToken();
  const url = `${BASE_URL}${USER_REPORT}`;
  return fetch(url, {
      method: GET,
      headers: {
        "Content-Type": "application/json",
        "userauth" : `bearer ${token}`
      },
    })
    .then(statusParsing)
    .then(jsonParsing);
};
